<template>
    <div id="dashboard">
        <DefaultPageComponent
        :loading="loading"
        :title="'Importação FGC'"
        :haveBackButton="true"
        @onBack="$router.push({name: 'dashboard'})"
        >

        <template #header>
            <b-col class="px-0" style="min-width:fit-content;">    
                <div class="d-flex flex-column">
                    <label for="">Data da Última importação</label>
                    <input class="form-control form-control-sm text-left" id="inputFilterDate" style="box-shadow: none; max-width: 240px; min-height: 56px;" disabled>
                </div>
            </b-col>
        </template>

        <!-- CONTENT -->
        <div class="py-3">
            <ImportationVariantComponent
            class="m-0"
            title="Tabela Posição geral Renda Fixa"
            :status="status == 2 || status == 0 ? 0 : 1"
            @change="handleFileChange"
            @import="postImport"
            ref="importComponent"
            />
        </div>

        <template #footer>
            <b-row class="mx-0" align-h="end">
                    <CustomButton
                    :loading="importations.diversification.loading || loading || loadingSubmit"
                    @click="$router.push('/')"
                    > 
                        Fechar
                    </CustomButton>
            </b-row>
        </template>

        </DefaultPageComponent>

    </div>  
</template>

<script>
import DefaultPageComponent from '@/components/DefaultPageComponent.vue';
import CustomButton from '@/components/CustomButton.vue';
import ImportationVariantComponent from '@/components/ImportationVariantComponent.vue';
export default {
    name: 'importFgc',
    components:{
        DefaultPageComponent,
        CustomButton,
        ImportationVariantComponent,
    },
    data () {
        return {
            loading: false,
            loadingSubmit: false,
            status: 0,
            file: null,
            importations: {
                diversification: {
                    loading: false,
                    quantity: 0,
                    name: '',
                },
            },
        }
    },
    mounted() {
        this.saveLog();
        this.getImportDate();
        this.getImportStatus();
    },
    methods: {
        getImportDate() {
            this.loading = true;

            this.$axios.get('fgc/date')
                .then((response) => {
                    const referenceDate = response.data?.reference_date;

                    if (referenceDate) {
                        const [year, month, day] = referenceDate.split('-');
                        const formattedDate = `${day}/${month}/${year}`;

                        const input = document.getElementById('inputFilterDate');
                        if (input) {
                            input.value = formattedDate;
                        }
                    }
                })
                .catch((error) => {
                    console.error('Erro ao buscar data de importação:', error);
                    // opcional: feedback para o usuário
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleFileChange(file) {
            if (!file) return;

            const fileName = file.name;

            // Verifica se começa com o prefixo esperado
            if (!fileName.startsWith('PosicaoGeral_RendaFixa_')) {
                this.$swal({
                    title: 'Atenção',
                    text: 'Nome do arquivo inválido. Certifique-se de selecionar um arquivo com o padrão PosicaoGeral_RendaFixa_<data>',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#28A745',
                    allowOutsideClick: false,
                    customClass: {
                        confirmButton: 'custom-confirm-button-class',
                    }
                });
                this.resetFileInput();
                return;
            }

            // Se o nome segue o padrão: Dia Mês DiaNumérico Ano
            const pattern = /^PosicaoGeral_RendaFixa_(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|Fev|Abr|Mai|Ago|Set|Out|Dez) \d{2} \d{4}/;

            if (!pattern.test(fileName)) {
                this.$swal({
                    title: 'Atenção',
                    text: 'Nome do arquivo inválido. Certifique-se de selecionar um arquivo com o padrão PosicaoGeral_RendaFixa_<data>',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#28A745',
                    allowOutsideClick: false,
                    customClass: {
                        confirmButton: 'custom-confirm-button-class',
                    }
                });
                this.resetFileInput();
                return;
            }

            // Salva arquivo
            this.file = file;
        },
        resetFileInput() {
            this.file = null;

            // Tenta resetar o componente via ref
            if (this.$refs.importComponent?.clear) {
                this.$refs.importComponent.clear();
            }
        },
        async postImport(){
            try{
                this.loading=true;
                var endpoint = 'fgc/import-fgc';

                const formData = new FormData();
                formData.append('sheet', this.file);

                await this.$axios.post(endpoint, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })

                this.getImportDate();
                this.resetFileInput();
                this.getImportStatus();
            }
            catch(error){
                console.log(error);
                this.$swal({
                    title: 'Atenção',
                    text: 'Houve um erro ao importar a tabela de FGC!',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#28A745',
                    allowOutsideClick: false,
                    customClass: {
                        confirmButton: 'custom-confirm-button-class',
                    }
                });
            }
            finally{ this.loading=false; }
        },
        saveLog () {
            let objLog = {
                description: 'Importação FGC'
            }

            this.$axios.post('logs', objLog).then((response) => {
                if(response.status != 201) {
                    console.log(response);
                }
            }).catch((error) => {
                console.log(error);
            });
        },
        getImportStatus() {
            this.loading=true;
            this.$axios.get('fgc/status').then((response) => {
                this.status = response.data.status
            })
            .finally(()=>{
                this.loading=false;
            })
        },
    }
}
</script>

<style>
    #dashboard {
        height: calc(100vh - 125px);
    }

    .form-control {
        background-color: #262625 !important;
        border: 1px solid #535252 !important;
        color: #E5E2E1 !important;
        border-radius: 10px !important;
    }
</style>
